<template>
  <div class="contain">
    <div class="pg-pd12">
      <div class="record-num">共{{totalElements}}条扣分记录</div>
      <div class="record-list">
        <div class="record-item line_bottom" v-for="(item,index) in recordList" :key="index">
          <div class="record-item-tit" :class="!item.show?'on':''" @click="changeHide(index,item.show)">{{item.subName}}</div>
          <div class="content" :class="item.show?'hide':''">
            <div class="record-item-cont"  v-for="(item1,index1) in item.subList.slice(0, 5)" :key="index1" >
              <div class="line"  v-if=" item.dealType === 'B3'">
                <div class="txt">
                  <span class="txt-tit">扣分原因：</span>
                  <span class="txt-cont">{{item1.deductionReason}}</span>
                </div>
                <div class="right-txt-line">
                  <div class="score" :class="item1.isExceed ? 'txtDec' : ''">-{{item1.deductionStr}}分</div>
                  <div class="timememo"  v-if="item1.isExceed == 1 ">已达扣分上限</div>
                </div>
              </div>
              <div class="line" v-if="item.dealType ==='B1' || item.dealType ==='B2'">
                <div class="txt">
                  <span class="txt-tit">发生地区：</span>
                  <span class="txt-cont">{{item1.happenCityName}}</span>
                </div>
                <div class="right-txt-line">
                  <div class="score" :class="item1.isExceed ? 'txtDec' : ''">-{{item1.deductionStr}}分</div>
                  <div class="timememo"  v-if="item1.isExceed == 1 ">已达扣分上限</div>
                </div>
              </div>
              <div class="line" v-if="item.dealType ==='B1'">
                <div class="txt">
                  <span class="txt-tit">响应时长：</span>
                  <span class="txt-cont">{{item1.answerTime|filt}}</span>
                </div>
              </div>
              <div class="line" v-if="item.dealType === 'B2'">
                <div class="txt">
                  <span class="txt-tit">处理时长：</span>
                  <span class="txt-cont">{{item1.dealDuration}}</span>
                </div>
              </div>
              <!-- <div class="line" v-if="item1.accidentTime">
                <div class="txt">
                  <span class="txt-tit">发生时间：</span>
                  <span class="txt-cont">{{item1.accidentTime}}</span>
                </div>
              </div> -->
              <div class="line" v-if="item.dealType === 'B3'">
                <div class="txt">
                  <span class="txt-tit">扣分时间：</span>
                  <span class="txt-cont">{{item1.deductionTime}}</span>
                </div>
              </div>
              <div class="line" @click="navTo(item1)">
                <div class="to-detail">
                  <div>查看详情</div>
                  <img src="@/assets/image/tb-right.png" />
                </div>
              </div>
            </div>
            <div v-if="item.totalPages>1" class="ts-list" @click="navToAll(item)">
              查看更多
              <img class="img" src="@/assets/image/t-right.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 扣分记录列表
export default {
  name: "causeDeduction",
  props: {
    // 'id': String,
    noData: Object,
    recordList: Array,
    totalElements: Number
  },
  data() {
    return {
      onHide: false,
      pageType: this.$route.query.pageType,
    };
  },
  methods: {
    navToAll(item) {
      // sessionStorage.setItem("list", JSON.stringify(list));
      // this.$router.push({
      //   path: "/appraise/deducList-all",
      // });
      this.$emit('navToALL', item);
    },
    navTo(item) {
      this.$emit("navToDetail", item);
    },
    changeHide(index, key) {
      delete this.recordList[index].show;
      this.$set(this.recordList[index], "show", !key);
    },
  },
  mounted() {},
  computed: {
    // 计算扣分记录总条数
    totalNum() {
      let total = 0;
      for (let i = 0, length = this.recordList.length; i < length; i++) {
        total += parseInt(this.recordList[i].subList.length);
      }
      return total;
    },
  },
  created() {
    // 二级列表大于5条时收起
    for (let i = 0, length = this.recordList.length; i < length; i++) {
      if (this.recordList[i].subList.length > 5) {
        this.recordList[i].show = true;
      } else {
        this.recordList[i].show = false;
      }
    }
  },
  filters:{
          filt(value){
            if(value){
              return value;
            }else{
              return '未响应'
            }
          }
        }
};
</script>

<style lang="less" scoped>
.contain {
  margin-bottom: 24px;
  // margin-top: 24px;
  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;

    .record-num {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      line-height: 14px;
    }

    .record-list {
      background: #fff;
      margin-top: 12px;

      .record-item {
        padding-top: 16px;
        padding-bottom: 16px;
        // border-bottom: solid 1px #EEEEEE;

        &-tit {
          position: relative;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          margin: 0 16px;
        }

        &-tit::after {
          content: "";
          position: absolute;
          right: 0;
          width: 12px;
          height: 12px;
          background: url(../../../../assets/image/t-right.png) no-repeat;
          transform: rotate(90deg);
          background-size: 12px 12px;
          transition: all 0.2s;
        }

        &-tit.on::after {
          content: "";
          position: absolute;
          right: 0;
          width: 12px;
          height: 12px;
          background: url(../../../../assets/image/t-right.png) no-repeat;
          transform: rotate(-90deg);
          background-size: 12px 12px;
        }
        .content {
          height: auto;
          .record-item-cont {
            line-height: 20px;
            transition: all 0.2s;
            padding: 12px 16px;

            .line {
              display: flex;
              justify-content: space-between;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(102, 102, 102, 1);
              margin-bottom: 8px;
              .txt {
                display: flex;

                &-tit {
                  // width: 60px;
                }

                &-cont {
                  width: 192px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }

              .score {
                color: #ff4d4d;
              }

              .to-detail {
                position: relative;
                color: #36b374;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-top: 4px;
                height: 12px;
                width: 80px;
                div {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 50px;
                  line-height: 12px;
                }
                img {
                  position: absolute;
                  left: 50px;
                  top: -1px;
                  width: 12px;
                  height: 12px;
                }
              }
            }

            .line:last-child {
              margin-bottom: 0;
            }
          }
          .record-item-cont:last-child {
            padding-bottom: 0;
          }
          .ts-list {
            width: 100%;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(155, 155, 155, 1);
            position: relative;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            .img {
              position: absolute;
              display: inline-block;
              width: 10px;
              height: 10px;
              top: 0;
              img {
                width: 100%;
              }
            }
          }
        }

        .hide {
          height: 0;
          margin-top: 0;
          overflow: hidden;
        }
      }
      .line_bottom:last-child::after {
        background: none;
      }
    }
  }
  .right-txt-line{
     position: relative;
  }
  .txtDec{
    text-decoration: line-through;
  }
  .timememo {
    color: #ff8c19;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    // text-align: right;
    width: 100px;
    margin-top: 6px;
    position: absolute;
    right: -30px;
    top: 14px;
  }
}
</style>
